// import { getEnvironment } from 'config/environment';
import { brand } from "config/brand"
import cx from "classnames"
import * as React from "react"
import * as styles from "./styles.module.scss"
import Link from "gatsby-link"

export interface FooterProps {
  loanType?: string
}

const Footer: React.FC<FooterProps> = ({ loanType }) => {
  return (
    <footer className={styles.footer} data-qa="home-page-footer">
      <div className={styles.pagePadding}>
        <div className={styles.container}>
          <section className={styles.section}>
            <h6 className={styles.eyebrow}>Contact Us</h6>
            <ul className={styles.list}>
              <li className={styles.item}>
                <a
                  className={cx({
                    [styles.link]: true,
                    [styles.ycbmLink]: true,
                  })}
                  // href={`${
                  //   getEnvironment().scheduleCallPath
                  // }?TRACKINGLOCATION=footer&TRACKINGBRANDING=general&loanType=${loanType}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Schedule a conversation
                </a>
                <a
                  className={cx({
                    [styles.link]: true,
                    [styles.ycbmLinkBlog]: true,
                  })}
                  // href={`${
                  //   getEnvironment().scheduleCallPath
                  // }?TRACKINGLOCATION=footer&TRACKINGBRANDING=general&loanType=${loanType}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Schedule a conversation
                </a>
              </li>
              <li className={styles.item}>
                <a className={styles.link} href="mailto:hello@better.com">
                  hello@better.com
                </a>
              </li>
              <li
                className={cx({
                  [styles.item]: true,
                  [styles.itemPhone]: true,
                })}
              >
                <div className={styles.phoneWrapper}>
                  <i
                    className={cx({
                      [styles.phoneIcon]: true,
                      ["bsk-icon-phone-thin"]: true,
                    })}
                  />
                  <a
                    className={styles.phoneNumber}
                    href={`tel:${brand.phone || "415-523-8837"}`}
                  >
                    {brand.phone || "415-523-8837"}
                  </a>
                </div>
              </li>
            </ul>
          </section>
          <section className={styles.section}>
            <h6 className={styles.eyebrow}>More from Better</h6>
            <ul className={styles.list}>
              <li className={styles.item}>
                <a className={styles.link} href="/content">
                  Resources
                </a>
              </li>
              <li className={styles.item}>
                <Link className={styles.link} to="/about-us/careers">
                  Careers
                </Link>
              </li>
              <li
                className={cx({
                  [styles.item]: true,
                  [styles.itemSocial]: true,
                })}
              >
                <ul className={styles.socialIconWrapper}>
                  <a
                    className={styles.socialIcon}
                    href="https://www.facebook.com/Betterdotcom/"
                  >
                    <i
                      aria-hidden="true"
                      className="bsk-icon-social-facebook"
                    />
                  </a>
                  <a
                    className={styles.socialIcon}
                    href="https://twitter.com/betterdotcom"
                  >
                    <i aria-hidden="true" className="bsk-icon-social-twitter" />
                  </a>
                  <a
                    className={styles.socialIcon}
                    href="https://www.linkedin.com/company/10039382"
                  >
                    <i
                      aria-hidden="true"
                      className="bsk-icon-social-linkedin"
                    />
                  </a>
                </ul>
              </li>
            </ul>
          </section>
          <section className={styles.section}>
            <h6 className={styles.eyebrow}>Legal</h6>
            <ul className={styles.list}>
              <li className={styles.item}>
                <a
                  className={styles.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/330511"
                  data-qa="nmls-link"
                >
                  NMLS Consumer Access
                </a>
              </li>
              <li className={styles.item}>
                <Link
                  className={styles.link}
                  data-qa="privacy-policy"
                  to="/about-us/privacy-policy"
                >
                  Privacy Policy
                </Link>
              </li>
              <li className={styles.item}>
                <Link
                  className={styles.link}
                  data-qa="terms-of-use"
                  to="/about-us/terms-of-use"
                >
                  Terms of Use
                </Link>
              </li>
              <li className={styles.item}>
                <Link
                  className={styles.link}
                  data-qa="licensing-disclosures"
                  to="/about-us/licensing-disclosure"
                >
                  Disclosures &amp; Licensing
                </Link>
              </li>
              <li className={styles.item}>
                <Link
                  className={styles.link}
                  data-qa="affiliated-business"
                  to="/about-us/affiliated-business"
                >
                  Affiliated Business
                </Link>
              </li>
              <li
                className={styles.item}
                className={cx({
                  [styles.item]: true,
                  [styles.itemAccreditations]: true,
                })}
              >
                <ul className={styles.accreditations}>
                  <li className={styles.accreditation}>
                    <i
                      className={cx({
                        [styles.equalHousingOpportunity]: true,
                        ["bsk-icon-equal-housing-lender"]: true,
                      })}
                    />
                  </li>
                  <li className={styles.accreditation}>
                    <a
                      className={styles.bbb}
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.bbb.org/new-york-city/business-reviews/mortgage-brokers/better-mortgage-in-new-york-ny-165686"
                      data-qa="bbb-link"
                    >
                      <i className="bsk-icon-bbb" />
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </section>
          <section className={styles.section}>
            <h6 className={styles.eyebrow}>We're Better</h6>
            <div className={styles.item}>
              <p className={styles.mission}>
                Better is a direct lender dedicated to providing a fast,
                transparent digital mortgage experience backed by superior
                customer support.
              </p>
              <p className={styles.mission}>
                From our offices in New York City, we're using technology to
                change the way people finance their homes, for the better.
              </p>
            </div>
          </section>
        </div>
        <div className={styles.disclaimer}>
          <small className={styles.disclaimerText}>
            {brand.name} is a direct lender. All rights reserved. NMLS #330511
          </small>
          <small
            className={styles.disclaimerText}
            itemProp="publisher"
            itemScope
            itemType="https://schema.org/Organization"
          >
            &copy; <span itemProp="name">{brand.legalName}</span> |{" "}
            <span itemProp="address">
              250 Greenwich St, FL 36, New York, NY 10006
            </span>
            <meta
              itemProp="logo"
              content="https://better.com/static/images/better-logo-square-with-margin.png"
            />
          </small>
          <small className={styles.disclaimerText}>
            Loans made or arranged pursuant to a California Finance Lenders Law
            License.
          </small>
          <small className={styles.disclaimerText}>
            This site is not authorized by the New York State Department of
            Financial Services. No mortgage solicitation activity or loan
            applications for properties located in the State of New York can be
            facilitated through this site.
          </small>
          <small className={styles.disclaimerText}>
            Not available in all states.
          </small>
        </div>
      </div>
    </footer>
  )
}

export default Footer
